export default __webpack_public_path__ + "static/media/flower13.96d1815c.jpg";